import { defineStore } from "pinia";
import { computed, toRefs, reactive } from "vue";
import type { IDomainCoordinate } from "#imports";

// Define the state interface
type IState = {
  isLoaded: boolean;
  coordinate?: IDomainCoordinate;
  city?: string;
  country?: string;
  region?: string;
  regionCode?: string;
};

// Helper function to create the initial state
function createInitialState(): IState {
  return {
    isLoaded: false,
    coordinate: undefined,
    city: undefined,
    country: undefined,
    region: undefined,
    regionCode: undefined,
  };
}

export const useGeoIpLocation = defineStore("geoIpLocation", () => {
  // Create a reactive state object using the initial state
  const state = reactive<IState>(createInitialState());

  // Helper function to reset the state to its initial values
  function reset() {
    Object.assign(state, createInitialState());
  }

  // Helper function to patch the state with a partial object
  function patch(patch: Partial<IState>) {
    Object.assign(state, patch);
  }

  const searchablePlace = computed(() => {
    const city = state.city?.trim();
    const region = state.region?.trim();

    return city && region ? `${city} - ${region}` : city || region;
  });

  return {
    ...toRefs(state),
    state: computed(() => state),
    patch,
    reset,
    searchablePlace,
  };
});
